import lessonTypes from 'helpers/enums/lessonTypes'
import viewTypes from 'helpers/enums/viewTypes'

const viewsToLessonTypes = {
	[viewTypes.MY_ACTIVITIES]: lessonTypes.QUICK_LAUNCH,
	[viewTypes.INTERACTIVE_VIDEO_CREATE]: lessonTypes.VIDEO,
	[viewTypes.VIDEO_CREATE]: lessonTypes.VIDEO,
	[viewTypes.VIDEO_STANDALONE_CREATE]: lessonTypes.VIDEO,
	[viewTypes.TIME_TO_CLIMB_CREATION]: lessonTypes.TIME_TO_CLIMB,
	[viewTypes.TIME_TO_CLIMB_STANDALONE_CREATION]: lessonTypes.TIME_TO_CLIMB,
	[viewTypes.MATCHING_PAIRS_CREATION]: lessonTypes.MATCHING_PAIRS,
	[viewTypes.MATCHING_PAIRS_STANDALONE_CREATION]: lessonTypes.MATCHING_PAIRS,
	[viewTypes.DRAW_IT_CREATION]: lessonTypes.DRAW_IT,
	[viewTypes.DRAW_IT_STANDALONE_CREATION]: lessonTypes.DRAW_IT,
}

export default view => viewsToLessonTypes[view] || ''
